<template>
  <div>
    <h2>{{ error?.statusCode }}</h2>
    <div>{{ error?.message }}</div>
    <div>{{ error?.stack }}</div>
    <button @click="handleError">Clear errors</button>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';

type Props = {
  error: NuxtError;
};
defineProps<Props>();

const handleError = () => clearError({ redirect: '/' });
</script>
